import { render, staticRenderFns } from "./Flatform.vue?vue&type=template&id=321633f2&scoped=true&"
import script from "./Flatform.vue?vue&type=script&lang=js&"
export * from "./Flatform.vue?vue&type=script&lang=js&"
import style0 from "./Flatform.vue?vue&type=style&index=0&id=321633f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321633f2",
  null
  
)

export default component.exports